import { formatDateInLocale, formatPrice, getNumberOfGuests } from '@fshr/shared';

import type { EventProduct } from './types';

type Translate = (text: string, params?: (string | number)[]) => string;

/** The lines the popup shows for the event product that was just added to the cart. */
export default function getAddedToCartSummary(item: EventProduct, t: Translate, locale: string) {
	const total = item.productTotal?.totalPrice;
	return {
		name: item.name,
		image: item.images?.[0]?.url,
		dateTime: [
			item.date &&
				formatDateInLocale(
					item.date.slice(0, 10),
					'MMM d',
					'yyyy-MM-dd',
					locale as Parameters<typeof formatDateInLocale>[3]
				),
			item.timeOfDay?.toLowerCase(),
		]
			.filter(Boolean)
			.join(', '),
		details: [
			item.price?.priceName,
			getNumberOfGuests({ t, numberOfAdults: item.numAdults, numberOfChildren: item.numChildren }),
		]
			.filter(Boolean)
			.join(' | '),
		price:
			total?.amount === undefined
				? ''
				: formatPrice({ value: total.amount, currencyCode: total.currencyCode, locale }),
	};
}
